import { render, staticRenderFns } from "./marketAnalysis.vue?vue&type=template&id=ac27f338&scoped=true"
import script from "./marketAnalysis.vue?vue&type=script&lang=js"
export * from "./marketAnalysis.vue?vue&type=script&lang=js"
import style0 from "./marketAnalysis.vue?vue&type=style&index=0&id=ac27f338&prod&lang=scss&scoped=true"
import style1 from "./marketAnalysis.vue?vue&type=style&index=1&id=ac27f338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac27f338",
  null
  
)

export default component.exports